import React, { useState, useEffect } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import { FaChevronDown } from "react-icons/fa";
import { IoPersonCircle } from "react-icons/io5";
import { MdOutlineLogout } from "react-icons/md";
import "./Bookfetch.css";
// import { useNavigate } from "react-router-dom";
import { getAllKatBookSubjects, GetBookCountforAll, GetBookUnitSessions, GetUnitCountforAll, GetSessionCountforAll } from "../../Services/ApiService";
import CryptoJS from "crypto-js";
import Header from "../header/Header";

const Bookfetch = ({
  activeTab,
  handleTabClick,
  studentregisterModal,
  setStudentRegisterModal,
  ParentregisterModal,
  setParentRegisterModal,
  TeacherregisterModal,
  setTeacherregisterModal,
}) => {
  let KatbookUrl = `https://katbook.explorencertkatbook.com`;
  // let KatbookUrl = `http://localhost:8000`;

  const secretKey = "KampusNcrt";
  const key = "KPOSTKatBooks#$*(@#)!!";
  const UserProfileData = JSON.parse(localStorage.getItem("userData"));
  console.log(UserProfileData);
  const encryptedSubjects = localStorage.getItem("encryptedSubjects");
  const decryptedSubjects = CryptoJS.AES.decrypt(encryptedSubjects, secretKey);
  const subjects = JSON.parse(decryptedSubjects.toString(CryptoJS.enc.Utf8));
  const usercode = localStorage.getItem("userCode");

  const UserToken = localStorage.getItem("token");

  const decrypteduserCode = CryptoJS.AES.decrypt(usercode, secretKey);
  const userrescode = JSON.parse(decrypteduserCode.toString(CryptoJS.enc.Utf8));

  const decryptedRegUser = CryptoJS.AES.decrypt(userrescode, "!@#$%^");
  const RegUserRes = decryptedRegUser.toString(CryptoJS.enc.Utf8);

  const userid = localStorage.getItem("userID");
  const decrypteduserIDD = CryptoJS.AES.decrypt(userid, secretKey);
  const userresidd = JSON.parse(decrypteduserIDD.toString(CryptoJS.enc.Utf8));

  const navigate = useNavigate();
  const [dropdown, setDropdown] = useState(false);
  const handleclick = () => {
    setDropdown(!dropdown);
  };

  const [userData, setUserData] = useState([]);
  const [userName, setUserName] = useState([]);
  const [subjectArr, setsubjectArr] = useState([]);
  const [userCode, setuserCode] = useState("");
  const [userId, setuserID] = useState("");
  const [Bookencrypteddata, setBookencrypteddata] = useState("");
  const [standardArr, setstandardArr] = useState([]);
  const [addbookOpen, setaddbookOpen] = useState(false);
  const [coverReportOpen, setCoverReportOpen] = useState(false);
  const [coverUnitOpen, setCoverUnitOpen] = useState(false);
  const [coverSessionOpen, setCoverSessionOpen] = useState(false);
  const [coverageReport, setcoverageReport] = useState([]);
  const [coverageReportUnit, setcoverageReportUnit] = useState([]);
  const [coverageReportSession, setcoverageReportSession] = useState([]);
  const [booklistloading, setbooklistloading] = useState(false);
  const [bookunitSessions, setbookunitSessions] = useState([]);
  

  const coverageArr = [
    { label: "Enhanced Content", totalCount: "totalAddContentCount", studentCount: "addContentCompleted", type: "addContent", class: "coverthreejai333", translate: "enhanceContent" },
    { label: "Concept Videos", totalCount: "totalConceptVideos", studentCount: "conceptVideosViewed", type: "concept", class: "coverthreejai444", translate: "conceptvideo" },
    { label: "Explanation Videos", totalCount: "totalTeachingVideos", studentCount: "teachingVideosViewed", type: "teaching", class: "coverthreejai555", translate: "teachingvideo" },
    { label: "3D Videos", totalCount: "total3DVideo", studentCount: "threeDVideosViewed", type: "3dvideo", class: "coverthreejai111", translate: "threeDVideo" },
    { label: "3D Models", totalCount: "total3DModel", studentCount: "threeDModelViewed", type: "3dmodel", class: "coverthreejai222", translate: "threeDModel" },
    { label: "3D Activities", totalCount: "total3DActivity", studentCount: "threeDActivitiesViewed", type: "3dactivity", class: "coverthreejai333", translate: "threeDActivity" },
    { label: "2D Animations", totalCount: "total2DAnimation", studentCount: "twoDAnimationViewed", type: "2danimation", class: "coverthreejai444", translate: "twoDAnimation" },
    { label: "Lesson Plan", totalCount: "totalLessonPlan", studentCount: "lessonPlanViewed", type: "lessonplan", class: "coverthreejai555", translate: "lessonPlan" },
    { label: "Virtual Lab Experiments", totalCount: "totalVirtualLab", studentCount: "virtualLabViewed", type: "virtuallab", class: "coverthreejai111", translate: "virtualLab" },
  ];

  const CoverageSubjects = [
    {
      id: 1,
      subject: "English",
      coverage: "50%",
      items: [
        { id: 1, name: "Enhanced Content Viewed", percent: 40 },
        { id: 2, name: "Explanation Video", percent: 50 },
        { id: 3, name: "Concept Videos Viewed", percent: 100 },
        { id: 4, name: "Lesson Plan Viewed", percent: 50 },
        { id: 5, name: "Virtual Lab Viewed", percent: 100 },
        { id: 6, name: "Notes Made", percent: 40 },
        { id: 7, name: "Highlights Made", percent: 10 },
        { id: 8, name: "Hyperlink Made", percent: 50 },
        { id: 9, name: "Clarification Posted", percent: 100 },
        { id: 10, name: "Book Marks Made", percent: 10 },
      ],
    },
    {
      id: 2,
      subject: "Mathematics",
      coverage: "45%",
      items: [
        { id: 1, name: "Enhanced Content Viewed", percent: 40 },
        { id: 2, name: "Explanation Video", percent: 50 },
        { id: 3, name: "Concept Videos Viewed", percent: 100 },
        { id: 4, name: "3D Videos Viewed", percent: 50 },
        { id: 5, name: "3D Models Viewed", percent: 100 },
        { id: 6, name: "3D Activities Viewed", percent: 40 },
        { id: 7, name: "Virtual Lab Viewed", percent: 10 },
        { id: 8, name: "Notes Made", percent: 50 },
        { id: 9, name: "Highlights Made", percent: 100 },
        { id: 10, name: "Hyperlink Made", percent: 10 },
        { id: 11, name: "Clarification Posted", percent: 50 },
        { id: 12, name: "Book Marks Made", percent: 10 },
      ],
    },
    {
      id: 3,
      subject: "हिंदी - मराठी",
      coverage: "55%",
      items: [
        { id: 1, name: "Enhanced Content Viewed", percent: 40 },
        { id: 2, name: "Explanation Video", percent: 50 },
        { id: 3, name: "Concept Videos Viewed", percent: 100 },
        { id: 4, name: "Lesson Plan Viewed", percent: 50 },
        { id: 5, name: "Virtual Lab Viewed", percent: 100 },
        { id: 6, name: "Notes Made", percent: 40 },
        { id: 7, name: "Highlights Made", percent: 10 },
        { id: 8, name: "Hyperlink Made", percent: 50 },
        { id: 9, name: "Clarification Posted", percent: 100 },
        { id: 10, name: "Book Marks Made", percent: 10 },
      ],
    },
    {
      id: 4,
      subject: "गणित - आनंदमय",
      coverage: "60%",
      items: [
        { id: 1, name: "Enhanced Content Viewed", percent: 40 },
        { id: 2, name: "Explanation Video", percent: 50 },
        { id: 3, name: "Concept Videos Viewed", percent: 100 },
        { id: 4, name: "3D Videos Viewed", percent: 50 },
        { id: 5, name: "3D Models Viewed", percent: 100 },
        { id: 6, name: "3D Activities Viewed", percent: 40 },
        { id: 7, name: "Virtual Lab Viewed", percent: 10 },
        { id: 8, name: "Notes Made", percent: 50 },
        { id: 9, name: "Highlights Made", percent: 100 },
        { id: 10, name: "Hyperlink Made", percent: 10 },
        { id: 11, name: "Clarification Posted", percent: 50 },
        { id: 12, name: "Book Marks Made", percent: 10 },
      ],
    },
  ];

  useEffect(() => {
    const username = localStorage.getItem("username");

    setUserName(username);
    const encryptedStandard = localStorage.getItem("encryptedStandard");

    if (
      encryptedStandard !== null &&
      encryptedStandard !== undefined &&
      encryptedStandard !== ""
    ) {
      console.log(subjects);
      const decryptedStandard = CryptoJS.AES.decrypt(
        encryptedStandard,
        secretKey
      );
      const standard = JSON.parse(
        decryptedStandard.toString(CryptoJS.enc.Utf8)
      );
      setstandardArr(standard);
      console.log(standard, "standardstandard");
      // const storedUserData = localStorage.getItem('userData');
      // if (storedUserData) {
      //   const parsedUserData = JSON.parse(storedUserData);
      //   setUserData(parsedUserData);
      // }
      getSubjectDetails();
    } else {
      localStorage.removeItem("userID");
      localStorage.removeItem("userCode");
      localStorage.removeItem("username");
      localStorage.removeItem("encryptedMedium");
      localStorage.removeItem("encryptedSubjects");
      localStorage.removeItem("encryptedStandard");
      localStorage.removeItem("token");
      localStorage.removeItem("userData");
      localStorage.removeItem("IsUserAuth");
      localStorage.clear();

      navigate("/");
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("userID");
    localStorage.removeItem("userCode");
    localStorage.removeItem("username");
    localStorage.removeItem("encryptedMedium");
    localStorage.removeItem("encryptedSubjects");
    localStorage.removeItem("encryptedStandard");
    localStorage.removeItem("token");
    localStorage.removeItem("userData");
    localStorage.removeItem("IsUserAuth");
    localStorage.clear();

    navigate("/");
  };

  const getSubjectDetails = async (BookIDs) => {
    // console.log(BookIDs,"BookIDsBookIDs");
    // console.log(subjects.map(subject => subject._id),"BookIDsBookIDs");
    try {
      let bod = {
        bookIds: BookIDs ? BookIDs : subjects.map((subject) => subject._id),
      };

      let res = await getAllKatBookSubjects(bod);
      if (res?.success === true) {
        setsubjectArr(res.units);
        FetchAllBooks(res.units)
      } else {
        console.log(res.error, res, "testtstst");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const FetchAllBooks = async (subjectList) => {
  
      if (subjectList?.length !== 0) {
        const value = [];

        await subjectList.map(async (x, index) => {

            let response;
            const CountBody = {
              "bookId": x?.bookId,
              "studentId": UserProfileData?.userId,
              "refInstID": "789",
              "refMediumID": x?.medium ? x?.medium : 1,
              "refStandardID": x?.standard,
              "refSubjectID": x?.bookId,
            };
            // console.log("unit count 2","unit analytics");
            response = await GetBookCountforAll(CountBody);
        

            if(response?.success){

                  let resBooks = {
                    bookId: x?.bookId,
                    bookName: x?.book,
                    booksProgress: response?.value
                  }

                value.push(resBooks)
                console.log(value,"setcoverageReport");
                
              
              }

              // if(index + 1 === subjectArr?.length){
                setcoverageReport(value);
                setbooklistloading(false);
              // }

        });

        
      } else {
        setcoverageReport([])
        setbooklistloading(false)
      }

  };


  const FetchAllUnitAnalytics = async (bookId, dataList) => {
  
      if (dataList?.length !== 0) {
        const value = [];

        for(let as=0;as<dataList?.length;as++){

          console.log(dataList[as],"setcoverageReport");

          if(as > 0){

            let response;
            const CountBody = {
              "unitId": dataList[as]?.UnitId,
              "studentId": UserProfileData?.userId,
              "refInstID": "789",
              "refMediumID": subjectArr.filter(a => a?.bookId === bookId)?.length > 0 ? subjectArr.filter(a => a?.bookId === bookId)[0]?.medium : 1,
              "refStandardID": subjectArr.filter(a => a?.bookId === bookId)?.length > 0 ? subjectArr.filter(a => a?.bookId === bookId)[0]?.standard : "",
              "refSubjectID": bookId,
            };
            // console.log("unit count 2","unit analytics");
            response = await GetUnitCountforAll(CountBody);
        

            if(response?.success){

                  let resBooks = {
                    bookId: bookId,
                    unitId: dataList[as]?.UnitId,
                    unitName: dataList[as]?.UnitName,
                    booksProgress: response?.value
                  }
                console.log(resBooks,"setcoverageReport");
                value.push(resBooks)
                console.log(value,"setcoverageReport");
                
              
              }

              if(as + 1 === subjectArr?.length){
                setTimeout(() => {
                  setcoverageReportUnit(value);
                setbooklistloading(false);
                }, 100);
              }

            }

          }

        
      } else {
        setcoverageReportUnit([])
        setbooklistloading(false)
      }

  };

  const FetchAllSessionAnalytics = async (bookId, dataList) => {
     console.log(dataList,"setcoverageReport");
      if (dataList?.length !== 0) {
        const value = [];

        for(let as=0;as<dataList?.length;as++){

         

          if(as > 0){

            let response;
            const CountBody = {
              "sessionId": dataList[as]?.SessionId,
              "studentId": UserProfileData?.userId,
              "refInstID": "789",
              "refMediumID": subjectArr.filter(a => a?.bookId === bookId)?.length > 0 ? subjectArr.filter(a => a?.bookId === bookId)[0]?.medium : 1,
              "refStandardID": subjectArr.filter(a => a?.bookId === bookId)?.length > 0 ? subjectArr.filter(a => a?.bookId === bookId)[0]?.standard : "",
              "refSubjectID": bookId,
            };
            // console.log("unit count 2","unit analytics");
            response = await GetSessionCountforAll(CountBody);
        

            if(response?.success){

                  let resBooks = {
                    bookId: bookId,
                    sessionId: dataList[as]?.SessionId,
                    SessionName: dataList[as]?.SessionName,
                    booksProgress: response?.value
                  }
                console.log(resBooks,"setcoverageReport");
                value.push(resBooks)
                console.log(value,"setcoverageReport");
                
              
              }

              if(as + 1 === subjectArr?.length){
                setTimeout(() => {
                setcoverageReportSession(value);
                setbooklistloading(false);
                }, 100);
              }

            }

          }

        
      } else {
        setcoverageReportSession([])
        setbooklistloading(false)
      }

  };

  

  const FetchAllUnitsSessions = async (bookId) => {
    let response = await GetBookUnitSessions(bookId);
    if(response?.success && response?.variable?.length > 0){
      setbookunitSessions(response?.variable[0]?.Units)
      FetchAllUnitAnalytics(bookId, response?.variable[0]?.Units)
    }
  }

  const handleBookClick = (subjectId) => {
    console.log(subjectId, "subjectId");
    const encryptedStandard = localStorage.getItem("encryptedStandard");
    const decryptedStandard = CryptoJS.AES.decrypt(
      encryptedStandard,
      secretKey
    );
    const standard = JSON.parse(decryptedStandard.toString(CryptoJS.enc.Utf8));

    const encryptedMedium = localStorage.getItem("encryptedMedium");
    const decryptedMedium = CryptoJS.AES.decrypt(encryptedMedium, secretKey);
    const medium = JSON.parse(decryptedMedium.toString(CryptoJS.enc.Utf8));

    const usercode = localStorage.getItem("userCode");

    const decrypteduserCode = CryptoJS.AES.decrypt(usercode, secretKey);
    const userrescode = JSON.parse(
      decrypteduserCode.toString(CryptoJS.enc.Utf8)
    );

    const decryptedRegUser = CryptoJS.AES.decrypt(userrescode, "!@#$%^");
    const RegUserRes = decryptedRegUser.toString(CryptoJS.enc.Utf8);

    const userid = localStorage.getItem("userID");
    const decrypteduserIDD = CryptoJS.AES.decrypt(userid, secretKey);
    const userresidd = JSON.parse(decrypteduserIDD.toString(CryptoJS.enc.Utf8));

    const stdid = standard.map((standard) => standard._id);
    const mediumid = medium._id;
  };
  return (
    <div className="spacing">
      <Header
        studentregisterModal={studentregisterModal}
        setStudentRegisterModal={setStudentRegisterModal}
        ParentregisterModal={ParentregisterModal}
        setParentRegisterModal={setParentRegisterModal}
        TeacherregisterModal={TeacherregisterModal}
        setTeacherregisterModal={setTeacherregisterModal}
        userAuth={localStorage.getItem("IsUserAuth")}
        setaddbookOpen={setaddbookOpen}
        addbookOpen={addbookOpen}
        RefreshSubjects={(bookArray) => getSubjectDetails(bookArray)}
      />
      <div className="d-flex justify-content-between align-item-center px-4 py-2 ">
        <div style={{ width: "8%" }}>
          <img
            src="https://cdn.katbook.com/assets/sites/ncert/754664531418025984_HeaderEmbelem.png"
            alt="PM e-Vidth KATBOOK"
            style={{ width: "100%" }}
          />
        </div>

        <div className="d-flex align-items-center gap-5">
          <div className="d-flex align-item-center gap-2">
            <div>
              <img
                src="https://cdn.katbook.com/assets/sites/ncert/754664531585798144_ProfileLogo.png"
                alt="profile"
              />
            </div>
            <div
              className="d-flex gap-2 align-items-center"
              onClick={handleclick}
              style={{ cursor: "pointer" }}
            >
              <div className="d-flex flex-column">
                <div className="text">{userName}</div>
                <div className="section">
                  {UserProfileData?.userTypeId?.usertype === "Teacher"
                    ? "TEACHER"
                    : UserProfileData?.userTypeId?.usertype === "Parent"
                    ? "PARENT"
                    : UserProfileData?.userTypeId?.usertype === "Student"
                    ? "STUDENT"
                    : `${standardArr[0]?.variableName}`}{" "}
                </div>
              </div>
              <div className="pt-0">
                <FaChevronDown size={12} />
              </div>
            </div>
          </div>
        </div>
      </div>

      {dropdown && (
        <div className="d-flex flex-column gap-2 backgroundeffect ">
          <div className="account"> Account</div>
          <div className="sections  px-3 py-1">
            <IoPersonCircle size={20} />
            &nbsp;{userName}
          </div>
          {/* <div className='key px-3 py-1'><RiPushpinFill size={20} />&nbsp; @122334</div> */}
          <div className="sections px-3 py-1" onClick={handleLogout}>
            <MdOutlineLogout size={20} />
            &nbsp; Log Out
          </div>
        </div>
      )}

      <div className="px-4 ">
        <div className=" border ">
          <div className="background">
            <div className="d-flex align-items-center justify-content-between px-3 p-2">
              {coverReportOpen ? (
                <div className="katbooktext ">
                  Coverage Report of{" "}
                  {UserProfileData?.userTypeId?.usertype === "Parent"
                    ? `${UserProfileData?.studentId?.firstName} ${UserProfileData?.studentId?.lastName}'s Katbook`
                    : `${UserProfileData?.firstName}'s Katbook`}
                </div>
              ) : (
                <div className="katbooktext ">
                  {UserProfileData?.userTypeId?.usertype === "Parent"
                    ? `${UserProfileData?.studentId?.firstName} ${UserProfileData?.studentId?.lastName}'s KATBOOKs`
                    : `${UserProfileData?.firstName}'s KATBOOKs`}
                </div>
              )}
              {UserProfileData?.userTypeId?.usertype !== "Parent" && (
                <div className="d-flex align-items-center">
                  <div
                    className="addBookBtn cursor"
                    onClick={() => {
                      if(coverSessionOpen){
                        setCoverSessionOpen(false)
                        setCoverUnitOpen(true)
                        setCoverReportOpen(false)
                      } else if(coverUnitOpen){
                        setCoverUnitOpen(false)
                        setCoverSessionOpen(false)
                        setCoverReportOpen(true)
                      } else {
                        setCoverUnitOpen(false)
                        setCoverSessionOpen(false)
                        setCoverReportOpen(!coverReportOpen)
                      }
                      // setCoverReportOpen(!coverReportOpen);
                    }}
                  >
                    {coverReportOpen ? `Hide Coverage Report` : coverUnitOpen ? `Goto Book Coverage` : coverSessionOpen ? `Goto Unit Coverage` : `View Coverage Report`}
                  </div>
                  <div
                    className="addBookBtn cursor"
                    onClick={() => {
                      setaddbookOpen(true);
                      setCoverReportOpen(false);
                    }}
                  >
                    {" "}
                    Add Katbook
                  </div>
                </div>
              )}
            </div>

            {!coverReportOpen && !coverUnitOpen && !coverSessionOpen && (
              <div className="d-flex flex-wrap gap-4 px-5 py-3 ">
                {subjectArr.map((x) => {
                  const BooksText = `${
                    x.path.split('"parentVaribaleId"')[0]
                  }"parentVaribaleId":{"username":"${userresidd}","code":"${UserToken}"}}/${
                    x?.standard
                  }/${x?.bookId}/789/${x?.medium}`;

                  const Bookencrypted = CryptoJS.AES.encrypt(
                    JSON.stringify(BooksText),
                    key
                  ).toString();

                  const StdID =
                    subjects.filter((q) => q._id === x._id).length > 0
                      ? subjects.filter((q) => q._id === x._id)[0]
                          ?.parentVaribaleId?.parentVaribaleId?.variableName
                      : "";
                  return (
                    <>
                      <div
                        className="d-flex flex-column gap-2 align-items-center justify-content-start color"
                        style={{
                          width: "12%",
                          padding: "15px",
                        }}
                      >
                        <div
                          className="d-flex justify-content-center w-100"
                          key={x.bookId}
                          onClick={() => {
                            var newOpen = window.open(
                              `${KatbookUrl}/#/auth/book/${Bookencrypted}`
                            );
                            if (
                              newOpen == null ||
                              typeof newOpen == "undefined"
                            ) {
                              alert("Turn off your pop-up blocker!");
                            }
                            //   window.close();
                          }}
                        >
                          <img
                            style={{ width: "80%", cursor: "pointer" }}
                            src={x.coverImage}
                            alt="books"
                          />
                        </div>
                        <div className="subjectname">
                          {x.book}{" "}
                          {UserProfileData?.userTypeId?.usertype ===
                            "Teacher" && StdID
                            ? StdID
                            : UserProfileData?.userTypeId?.usertype ===
                                "Student" && StdID
                            ? StdID
                            : ""}
                        </div>

                        {/* <div className='d-flex  gap-2 align-items-center'>
                    <progress id="file" value="40" max="100"></progress>
                    <div className='value'>40%</div>
                  </div> */}
                      </div>
                    </>
                  );
                })}
              </div>
            )}

            {coverReportOpen && !coverUnitOpen && !coverSessionOpen && (
              <div className="row justify-content-start py-3 padtwoperen">
                {coverageReport?.length > 0 && coverageReport?.map((subject) => (
                  <div
                    className="col-md-4 mb-4 d-flex justify-content-center"
                  >
                    <div className="report-card w-100">
                      {/* Subject Title */}

                      <div className="d-flex gap10px">
                        <div className="report-circle">
                          {" "}
                          <div> {subject?.booksProgress?.student?.contentCompleted > 0 ? Math.round((subject?.booksProgress?.student?.contentCompleted * 100)/subject?.booksProgress?.total?.sessionCount) : 0}% </div>{" "}
                          <div className="report-circlespan">
                            Lesson Coverage
                          </div>{" "}
                        </div>

                        <div className="w-100">
                          <h3 className="report-title text-center cursor-pointer"
                          onClick={() => {
                            setCoverUnitOpen(true)
                            setCoverReportOpen(false)
                            setCoverSessionOpen(false)
                            FetchAllUnitsSessions(subject?.bookId)
                          }}
                          >
                            {subject.bookName}
                          </h3>

                          {/* Items */}
                          <div className="report-items">
                            {coverageArr?.length > 0 && coverageArr?.map((item) => (
                              <div className="report-item">
                                <div className="report-label d-flex justify-content-between">
                                  <span>{item.label}</span>
                                  <span className="">
                                      {`${subject?.booksProgress?.total[item?.totalCount] === 0 ? 0 : (subject?.booksProgress?.student[item?.studentCount] ? subject?.booksProgress?.student[item?.studentCount] > subject?.booksProgress?.total[item?.totalCount] ? "100" : Math.round((subject?.booksProgress?.student[item?.studentCount] * 100)/subject?.booksProgress?.total[item?.totalCount]) : 0)}%`}
                                  </span>
                                </div>
                                <div className="report-bar">
                                  <div
                                    className="report-bar-fill"
                                    style={{ 
                                      width: `${subject?.booksProgress?.total[item?.totalCount] === 0 ? 0 : (subject?.booksProgress?.student[item?.studentCount] ? subject?.booksProgress?.student[item?.studentCount] > subject?.booksProgress?.total[item?.totalCount] ? "100" : Math.round((subject?.booksProgress?.student[item?.studentCount] * 100)/subject?.booksProgress?.total[item?.totalCount]) : 0)}%`,
                                     }}
                                  >
                                    {/* <span className="report-bar-percent">
                                      {`${subject?.booksProgress?.total[item?.totalCount] === 0 ? 0 : (subject?.booksProgress?.student[item?.studentCount] ? subject?.booksProgress?.student[item?.studentCount] > subject?.booksProgress?.total[item?.totalCount] ? "100" : Math.round((subject?.booksProgress?.student[item?.studentCount] * 100)/subject?.booksProgress?.total[item?.totalCount]) : 0)}%`}
                                    </span> */}
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}


            {!coverReportOpen && coverUnitOpen && !coverSessionOpen && (
              <div className="row justify-content-start py-3 padtwoperen">
                {coverageReportUnit?.length > 0 && coverageReportUnit?.map((subject) => (
                  <div
                    className="col-md-4 mb-4 d-flex justify-content-center"
                  >
                    <div className="report-card w-100">
                      {/* Subject Title */}

                      <div className="d-flex gap10px">
                        <div className="report-circle">
                          {" "}
                          <div> {subject?.booksProgress?.student?.contentCompleted > 0 ? Math.round((subject?.booksProgress?.student?.contentCompleted * 100)/subject?.booksProgress?.total?.sessionCount) : 0}% </div>{" "}
                          <div className="report-circlespan">
                            Lesson Coverage
                          </div>{" "}
                        </div>

                        <div className="w-100">
                          <h3 className="report-title text-center cursor-pointer"
                          onClick={() => {
                            FetchAllSessionAnalytics(subject?.bookId, bookunitSessions.filter(x => x?.unitId === subject?.unitId)?.length > 0 ? bookunitSessions.filter(x => x?.unitId === subject?.unitId)[0]?.SessionDetails : "")
                          }}
                          >
                            {subject.unitName}
                          </h3>

                          {/* Items */}
                          <div className="report-items">
                            {coverageArr?.length > 0 && coverageArr?.map((item) => (
                              <div className="report-item">
                                <div className="report-label d-flex justify-content-between">
                                  <span>{item.label}</span>
                                  <span className="">
                                      {`${subject?.booksProgress?.total[item?.totalCount] === 0 ? 0 : (subject?.booksProgress?.student[item?.studentCount] ? subject?.booksProgress?.student[item?.studentCount] > subject?.booksProgress?.total[item?.totalCount] ? "100" : Math.round((subject?.booksProgress?.student[item?.studentCount] * 100)/subject?.booksProgress?.total[item?.totalCount]) : 0)}%`}
                                  </span>
                                </div>
                                <div className="report-bar">
                                  <div
                                    className="report-bar-fill"
                                    style={{ 
                                      width: `${subject?.booksProgress?.total[item?.totalCount] === 0 ? 0 : (subject?.booksProgress?.student[item?.studentCount] ? subject?.booksProgress?.student[item?.studentCount] > subject?.booksProgress?.total[item?.totalCount] ? "100" : Math.round((subject?.booksProgress?.student[item?.studentCount] * 100)/subject?.booksProgress?.total[item?.totalCount]) : 0)}%`,
                                     }}
                                  >
                                    {/* <span className="report-bar-percent">
                                      {`${subject?.booksProgress?.total[item?.totalCount] === 0 ? 0 : (subject?.booksProgress?.student[item?.studentCount] ? subject?.booksProgress?.student[item?.studentCount] > subject?.booksProgress?.total[item?.totalCount] ? "100" : Math.round((subject?.booksProgress?.student[item?.studentCount] * 100)/subject?.booksProgress?.total[item?.totalCount]) : 0)}%`}
                                    </span> */}
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}


            {!coverReportOpen && !coverUnitOpen && coverSessionOpen && (
              <div className="row justify-content-start py-3 padtwoperen">
                {coverageReportSession?.length > 0 && coverageReportSession?.map((subject) => (
                  <div
                    className="col-md-4 mb-4 d-flex justify-content-center"
                  >
                    <div className="report-card w-100">
                      {/* Subject Title */}

                      <div className="d-flex gap10px">
                        <div className="report-circle">
                          {" "}
                          <div> {subject?.booksProgress?.student?.contentCompleted > 0 ? Math.round((subject?.booksProgress?.student?.contentCompleted * 100)/subject?.booksProgress?.total?.sessionCount) : 0}% </div>{" "}
                          <div className="report-circlespan">
                            Lesson Coverage
                          </div>{" "}
                        </div>

                        <div className="w-100">
                          <h3 className="report-title text-center"
                          >
                            {subject.SessionName}
                          </h3>

                          {/* Items */}
                          <div className="report-items">
                            {coverageArr?.length > 0 && coverageArr?.map((item) => (
                              <div className="report-item">
                                <div className="report-label d-flex justify-content-between">
                                  <span>{item.label}</span>
                                  <span className="">
                                      {`${subject?.booksProgress?.total[item?.totalCount] === 0 ? 0 : (subject?.booksProgress?.student[item?.studentCount] ? subject?.booksProgress?.student[item?.studentCount] > subject?.booksProgress?.total[item?.totalCount] ? "100" : Math.round((subject?.booksProgress?.student[item?.studentCount] * 100)/subject?.booksProgress?.total[item?.totalCount]) : 0)}%`}
                                  </span>
                                </div>
                                <div className="report-bar">
                                  <div
                                    className="report-bar-fill"
                                    style={{ 
                                      width: `${subject?.booksProgress?.total[item?.totalCount] === 0 ? 0 : (subject?.booksProgress?.student[item?.studentCount] ? subject?.booksProgress?.student[item?.studentCount] > subject?.booksProgress?.total[item?.totalCount] ? "100" : Math.round((subject?.booksProgress?.student[item?.studentCount] * 100)/subject?.booksProgress?.total[item?.totalCount]) : 0)}%`,
                                     }}
                                  >
                                    {/* <span className="report-bar-percent">
                                      {`${subject?.booksProgress?.total[item?.totalCount] === 0 ? 0 : (subject?.booksProgress?.student[item?.studentCount] ? subject?.booksProgress?.student[item?.studentCount] > subject?.booksProgress?.total[item?.totalCount] ? "100" : Math.round((subject?.booksProgress?.student[item?.studentCount] * 100)/subject?.booksProgress?.total[item?.totalCount]) : 0)}%`}
                                    </span> */}
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Bookfetch;
